import type { MessageRenderer, RendererConfig, RendererResult, AnimationState } from './types';

/**
 * Renderer that displays content character by character (typewriter effect)
 */
export class TypewriterRenderer implements MessageRenderer {
  render(
    _messageId: string,
    config: RendererConfig,
    currentState: AnimationState
  ): RendererResult {
    const visibleCount = currentState.visibleChars ?? 0;

    return {
      displayContent: config.content.slice(0, visibleCount),
      isComplete: visibleCount >= config.content.length,
    };
  }

  getInitialState(): AnimationState {
    return { visibleChars: 0 };
  }
}

